import AppVersionLine from './AppVersionLine';

export default AppVersionLine;
